export default __webpack_public_path__ + "static/media/TotalIP.ad23291c.svg";